let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1FHlD")).then(() => parcelRequire('dbQRg'));